import React from 'react';
import moment from 'moment';
type Props = {
  date: string;
};
export const DateSchedule = ({ date }: Props) => {
  const momentDate = moment(date);
  return (
    <div className="text-center">
      <div>{momentDate.format('MMM').toUpperCase()}</div>
      <div className="text-14">{momentDate.format('dd').toUpperCase()}</div>
      <div>{momentDate.format('DD')}</div>
    </div>
  );
};
